import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';

import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';

const DividendsTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = useDividendsDistributionModal();

  const columns = [
    {
      key: 'name',
      content: t('Name'),
    },

    {
      key: 'ndPercentage',
      content: t('%ND'),
      textPosition: 'right',
    },

    data.hasRetention
      ? {
          key: 'retentionPercentage',
          content: t('%Retention'),
          textPosition: 'right',
        }
      : null,

    data.hasRetention
      ? {
          key: 'grossAmount',
          content: t('GrossAmount'),
          textPosition: 'right',
        }
      : null,

    {
      key: 'toPerceive',
      content: t('ToPerceive'),
      textPosition: 'right',
    },
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default DividendsTableHeader;
